document.addEventListener("DOMContentLoaded", function () {


  const ani1 = document.querySelector(".ani1");
  const ani2 = document.querySelectorAll(".site-header__nav--desktop .main-menu__item");

  ani2.forEach((list) => {
    list.addEventListener("mouseover", () => {
      let position = list.getBoundingClientRect();
      ani1.classList.add("active");
      ani1.style.left = position.x - 16 + "px";
      ani1.style.top = 18 + "px";
      ani1.style.width = position.width + 32 + "px";

      // Check if the element has any of the specified classes
      if (list.classList.contains("main-menu__item--menu-red")) {
        ani1.classList.add("ani1-red");
      } else if (list.classList.contains("main-menu__item--menu-orange")) {
        ani1.classList.add("ani1-orange");
      } else if (list.classList.contains("main-menu__item--menu-brown")) {
        ani1.classList.add("ani1-brown");
      } else if (list.classList.contains("main-menu__item--header-btn")) {
        ani1.classList.remove("active");
      }

    });
  
    list.addEventListener("mouseout", () => {
      ani1.classList.remove("ani1-red");
      ani1.classList.remove("ani1-orange");
      ani1.classList.remove("ani1-brown");
      ani1.classList.remove("active");
    });
    
    // Check if the element has any of the specified menu-activated classes
    if (
      list.classList.contains("main-menu__item--parent--active") ||
      list.classList.contains("main-menu__item--ancestor--active") ||
      list.classList.contains("main-menu__item--active")
    ) {
      ani1.classList.add("active");
      list.dispatchEvent(new Event("mouseover"));
    }
  });

});